import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";

import { locale as navigationEnglish } from "./navigation/i18n/en";
import { locale as navigationTurkish } from "./navigation/i18n/tr";
import { LoopBackConfig } from "@lbsdk/*";
import { environment } from "@env/environment";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "fuse-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private fuseTranslationLoader: FuseTranslationLoaderService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.registerIcons();

    LoopBackConfig.setBaseURL(environment.apiBaseUrl);
    LoopBackConfig.setApiVersion("api");

    // Add languages
    this.translate.addLangs(["en", "tr"]);

    // Set the default language
    this.translate.setDefaultLang("en");

    // Set the navigation translations
    this.fuseTranslationLoader.loadTranslations(
      navigationEnglish,
      navigationTurkish
    );

    // Use a language
    this.translate.use("en");
  }

  registerIcons = () => {
    this.matIconRegistry.addSvgIcon(
      "stats",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../assets/stats.svg")
    );
  };
}
